










import Enumerable from "linq";
import { Component, Mixins, Prop, Emit, Watch } from "vue-property-decorator";
import { IHisInfoSelectDialog } from "../../his/dialogs";
import { InOutKinds } from "../../../domain/workflow/kinds";
import { ReceptionProofPeriod } from "../../../domain/workflow/reception";
import { DateDuration } from "../../../domain/system";
import { HisInformationListItem } from "../../../domain/his";
import { ReceptionDateTranslator } from "../../../domain/workflow";
import DateDurationPicker from "../../system/selectors/DateDurationPicker.vue";

@Component({
  components: {
    DateDurationPicker,
  }
})
export default class ProofPeriodDialogSelector extends Mixins() {
  @Prop()
  uniqueIndex: number;

  @Prop()
  currentIndex: number;

  @Prop()
  patientSelected: boolean;

  @Prop()
  proofPeriod: ReceptionProofPeriod;

  @Prop()
  hasData: boolean;

  @Prop()
  dialog: IHisInfoSelectDialog;

  @Prop({ default: false })
  isClearable: boolean;

  @Prop({ default: "選択" })
  labelOfSelect: string;

  @Prop({ default: "クリア" })
  labelOfClear: string;

  @Emit()
  update(index: number, value: ReceptionProofPeriod): void {}


  data(): any {
    return {
      inKind : InOutKinds.In,
      outKind : InOutKinds.Out,
      value: null as ReceptionProofPeriod,
    };
  }
  inKind: InOutKinds;
  outKind: InOutKinds;
  value: ReceptionProofPeriod;

  created(): void {
    this.setValue(this.proofPeriod);
  }

  @Watch("proofPeriod")
  onChangeProofPeriod(newValue: ReceptionProofPeriod, oldValue: ReceptionProofPeriod): void {
    this.setValue(newValue);
  }

  private setValue(target: ReceptionProofPeriod): void {
    this.value = target.clone(this.currentIndex);
  }

  get inOutKind(): InOutKinds {
    return this.value.type;
  }

  set inOutKind(source: InOutKinds) {
    this.value.type = source;
    this.update(this.currentIndex, this.value);
  }

  get period(): DateDuration {
    return this.value.period;
  }

  set period(source: DateDuration) {
    this.value.period = source;
    this.update(this.currentIndex, this.value);
  }

  get isSelectable(): boolean {
    return !!this.dialog && this.patientSelected && this.hasData; // データがなかったら選択ボタン押せないように
  }

  select(): void {

    const dateTranslator = new ReceptionDateTranslator();

    this.dialog.show().then(result => {
      // undefinedの時はキャンセル.
      if (result !== undefined) {
        const source = result.data as HisInformationListItem[];
        if (source === null) {
          this.period = new DateDuration(null, null);
          return;
        } else if (source === undefined || source.length === 0) {
          return;
        }

        this.inOutKind = InOutKinds.In;

        let from: Date;
        let to: Date;

        const fromItem = this.getItem(source, "ENTER_HOSP_DATE_TIME");
        if (fromItem) { from = dateTranslator.fromDateString(fromItem); }
        const toItem = this.getItem(source, "LEAVE_HOSP_DATE_TIME");
        if (toItem) { to = dateTranslator.fromDateString(toItem); }

        this.period = new DateDuration(from, to);
      }
    });
  }

  private getItem(items: HisInformationListItem[], name: string): string {
    return Enumerable.from(items[0].items).where(m => m.name === name).select(m => m.value).firstOrDefault();
  }

  clear(): void {
    this.value = new ReceptionProofPeriod(this.currentIndex);
    this.update(this.currentIndex, this.value);
  }
}
